<!-- <section>
  <div class="example-label">Basic</div>
  <div class="example-button-row">
    <button mat-button>Basic</button>
    <button mat-button disabled>Disabled</button>
    <a mat-button href="https://www.google.com/" target="_blank">Link</a>
  </div>
</section> -->

<!-- <section>
  <div class="example-label">Icon</div>
  <div class="example-button-row">
    <div class="example-flex-container">
      <button mat-icon-button aria-label="Example icon button with a vertical three dot icon">
        <mat-icon>more_vert</mat-icon>
      </button>
      <button mat-icon-button disabled aria-label="Example icon button with a open in new tab icon">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>
  </div>
</section> -->

<section>
  <button type="button"
    class="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-800 dark:bg-white dark:border-gray-700 dark:text-gray-900 dark:hover:bg-gray-200 me-2 mb-2"
    aria-label="Click to select an icon" [matTooltip]="'Icon Picker'" [matMenuTriggerFor]="iconPicker"
    #iconPickerTrigger="matMenuTrigger">
    <mat-icon class="icon-size-16" [svgIcon]="selectedIcon[0] + ':' + selectedIcon[1]"></mat-icon>
    <span>Select Icon</span>
  </button>
</section>

<davesa-loading-bar></davesa-loading-bar>
<mat-menu #iconPicker="matMenu" [overlapTrigger]="false" class="p-4">
  <input type="text" class="form-control input-sm p-2" [attr.autocomplete]="'off'" (input)="filterIcons($event)"
    [placeholder]="'Search Icon'" (click)="$event.stopPropagation()">
  <mat-select class="form-control input-sm p-2" (click)="$event.stopPropagation()" [(ngModel)]="selectedIcon[0]"
    (selectionChange)="filterItems($event)">
    @for (
    set of iconSets; track trackByFn($index, set)
    ) {
    <mat-option [value]="set.value">{{set.viewValue}}</mat-option>
    }
  </mat-select>
  <mat-divider></mat-divider>
  <ng-container>
    <div class="flex flex-row gap-3">
      <div class="basis-full">
        <main class="flex flex-col items-center justify-center p-2">
          <div class="grid grid-cols-6 gap-1 w-full 
                          justify-items-start">
            @if (filteredIcons$ | async; as icons) {
            @for (
            icon of icons.list;
            track trackByFn(i, icon);
            let i = $index

            ) {
            <div class="bg-card aspect-square rounded-md p-2 shadow flex flex-col items-center justify-center 
                                          xl:w-10 xl:w-10 lg:w-8 md:w-6 sm:w-6 xs:w-6 w-6 
                                          xl:h-10 xl:h-10 lg:h-8 md:h-6 sm:h-6 xs:h-6 h-6
                                          ">
              <a mat-icon-button [matTooltip]="icon" (click)="pickIcon(icons.namespace, icon)">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="font-bold xl:text-2xl lg:text-2xl md:text-md sm:text-md xs:text-md text-md p-4 text-center">
                    <mat-icon [ngClass]="iconSize" [svgIcon]="icons.namespace + ':' + icon"></mat-icon>
                  </div>
                </div>
              </a>
            </div>
            }
            }
          </div>
        </main>
      </div>
    </div>
  </ng-container>

</mat-menu>